// components/contact/ContactForm.js

import React, { useRef, useState } from "react";
import Link from "next/link";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
  const formRef = useRef();
  const [formStatus, setFormStatus] = useState({
    submitting: false,
    success: null,
    error: null,
  });

  const sendEmail = (e) => {
    e.preventDefault();
    setFormStatus({ submitting: true, success: null, error: null });

    emailjs
      .sendForm(
        "service_td5jarc", // Replace with your EmailJS Service ID
        "template_ivzqyqn", // Replace with your EmailJS Template ID
        formRef.current,
        "wOmWm38llC8kKk6bQ" // Replace with your EmailJS Public Key
      )
      .then(
        (result) => {
          setFormStatus({
            submitting: false,
            success: "Your message has been sent successfully!",
            error: null,
          });
          formRef.current.reset();
        },
        (error) => {
          console.error("EmailJS Error:", error);
          setFormStatus({
            submitting: false,
            success: null,
            error: "Failed to send the message. Please try again later.",
          });
        }
      );
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white dark:bg-jacarta-800 rounded-lg shadow-md">
      <h2 className="text-2xl font-semibold mb-6 text-gray-800 dark:text-white">
        Contact Us
      </h2>
      <form ref={formRef} onSubmit={sendEmail} id="contact-form">
        {/* Name and Email */}
        <div className="flex flex-col sm:flex-row sm:space-x-6">
          {/* Name */}
          <div className="mb-6 sm:w-1/2">
            <label className="block text-sm font-medium text-gray-700 dark:text-white">
              Name<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="user_name"
              className="mt-1 block w-full px-4 py-2 bg-gray-50 dark:bg-jacarta-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
              placeholder="Your Name"
              required
            />
          </div>

          {/* Email */}
          <div className="mb-6 sm:w-1/2">
            <label className="block text-sm font-medium text-gray-700 dark:text-white">
              Email<span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              name="user_email"
              className="mt-1 block w-full px-4 py-2 bg-gray-50 dark:bg-jacarta-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
              placeholder="your.email@example.com"
              required
            />
          </div>
        </div>

        {/* Message */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 dark:text-white">
            Message<span className="text-red-500">*</span>
          </label>
          <textarea
            name="message"
            rows="5"
            className="mt-1 block w-full px-4 py-2 bg-gray-50 dark:bg-jacarta-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
            placeholder="Your message here..."
            required
          ></textarea>
        </div>

        {/* Consent */}
        <div className="flex items-center mb-6">
          <input
            type="checkbox"
            name="agree_to_terms"
            className="h-4 w-4 text-green-600 border-gray-300 rounded focus:ring-green-500 dark:bg-jacarta-700 dark:border-gray-600"
            required
          />
          <label className="ml-2 block text-sm text-gray-700 dark:text-white">
            I agree to the{" "}
            <Link href="/terms">
              <a className="text-green-500 hover:underline dark:text-green-400">
                Terms of Service
              </a>
            </Link>
            .
          </label>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={formStatus.submitting}
          className={`w-full flex justify-center py-2  bg-jacarta-800 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
            formStatus.submitting
              ? "bg-green-300 cursor-not-allowed"
              : "bg-green-600 hover:bg-green-700"
          } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500`}
        >
          {formStatus.submitting ? "Submitting..." : "Submit"}
        </button>

        {/* Success and Error Messages */}
        {formStatus.success && (
          <div className="mt-4 text-green-600 text-sm text-center">
            {formStatus.success}
          </div>
        )}
        {formStatus.error && (
          <div className="mt-4 text-red-600 text-sm text-center">
            {formStatus.error}
          </div>
        )}
      </form>
    </div>
  );
};

export default ContactForm;
